import { Component } from '@angular/core';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs';
import { ConfigSection } from '../config-section';
import { DocumentCentreConfigHttpService } from '@admin/services/document-centre-config-http.service';
import { GetDocumentCentreConfigResponse, SaveDocumentCentreConfigRequest, DocumentCentreConfig, SaveDocumentCentreConfigResponse } from '@admin/models/document-centre-config';

@Component({
  selector: 'mojo-mojo-document-centre-settings',
  templateUrl: './document-centre-settings.component.html'
})
export class DocumentCentreSettingsComponent extends ConfigSection<GetDocumentCentreConfigResponse> {

  constructor(
    private readonly documentCentreConfigHttpService: DocumentCentreConfigHttpService,
    private readonly formBuilder: UntypedFormBuilder
  ) { super(); }

  initialiseConfig(): Observable<GetDocumentCentreConfigResponse> {
    return this.documentCentreConfigHttpService.getDocumentCentreConfig();
  }

  createForm(model: GetDocumentCentreConfigResponse): void {
    this.form = this.formBuilder.group({
      fileStoreRoot: [model.Config.FileStoreRoot, [Validators.required, Validators.maxLength(260)]],
    });
  }

  submit(): Observable<boolean> {
    const documentCentreConfig: DocumentCentreConfig = this.form.getRawValue();
    const request = new SaveDocumentCentreConfigRequest();
    request.Config = documentCentreConfig;
    return this.documentCentreConfigHttpService
      .saveDocumentCentreConfig(request)
      .pipe(
        tap((response: SaveDocumentCentreConfigResponse) => {
          if (response.Success === false) {
            this.form.controls['fileStoreRoot'].setErrors({ 'invalidFilePath': true });
          }
        }),
        map((response: SaveDocumentCentreConfigResponse) => response.Success)
      );
  }
}
